<section class="main-banner-wrapper">
  <div class="container">
    <div class="banner-wrapper-content">
      <h1>Эффективная и <a class="typewrite" data-period="3000" data-type='[ "прогрессивная"]' href="">
        <span class="wrap"></span></a> методика обучения</h1>
      <p>Secom - лидер по подготовке к ОРТ, рекордсмен по количеству золотых сертификатов, а также по количеству
        абитуриентов набравших свыше 200 баллов</p>
      <!-- <form>
                <input type="text" class="input-search" placeholder="What do you want to learn?">
                <button type="button">Search</button>
            </form> -->
    </div>
  </div>

  <div class="banner-wrapper-image text-center">
    <img alt="image" src="assets/img/banner.png">
  </div>
</section>
